module.exports = __webpack_public_path__ + "static/media/ontheground.5aa69fee.jpeg";